import { Box, Heading, Icon, Text } from '@betterment/samba-react';

import { Header } from './Header';

import { WithLayout } from '../../RetailApp/components/WithLayout';

export const Error: React.FC = () => {
  return (
    <WithLayout parts={{ sidebar: false }}>
      <Header />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
        }}
      >
        <Icon name="QuestionMarkCircle" size="large" color="icon.warning" css={{ marginBottom: 'space.400' }} />
        <Heading>We couldn't find your invitation</Heading>
        <Text>Contact your advisor for help.</Text>
      </Box>
    </WithLayout>
  );
};
